"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultTableNameParser = exports.getTableToken = exports.getNamespaceToken = exports.getFromKeywordToken = exports.getMetricNameToken = exports.getSelectStatisticToken = exports.getSelectToken = void 0;
const language_1 = require("../standardSql/language");
const types_1 = require("../types");
const getSelectToken = (currentToken) => { var _a; return (_a = currentToken === null || currentToken === void 0 ? void 0 : currentToken.getPreviousOfType(types_1.TokenType.Keyword, language_1.SELECT)) !== null && _a !== void 0 ? _a : null; };
exports.getSelectToken = getSelectToken;
const getSelectStatisticToken = (currentToken) => {
    var _a;
    const assumedStatisticToken = (_a = (0, exports.getSelectToken)(currentToken)) === null || _a === void 0 ? void 0 : _a.getNextNonWhiteSpaceToken();
    return (assumedStatisticToken === null || assumedStatisticToken === void 0 ? void 0 : assumedStatisticToken.isVariable()) || (assumedStatisticToken === null || assumedStatisticToken === void 0 ? void 0 : assumedStatisticToken.isFunction()) ? assumedStatisticToken : null;
};
exports.getSelectStatisticToken = getSelectStatisticToken;
const getMetricNameToken = (currentToken) => {
    var _a, _b;
    // statistic function is followed by `(` and then an argument
    const assumedMetricNameToken = (_b = (_a = (0, exports.getSelectStatisticToken)(currentToken)) === null || _a === void 0 ? void 0 : _a.next) === null || _b === void 0 ? void 0 : _b.next;
    return (assumedMetricNameToken === null || assumedMetricNameToken === void 0 ? void 0 : assumedMetricNameToken.isVariable()) || (assumedMetricNameToken === null || assumedMetricNameToken === void 0 ? void 0 : assumedMetricNameToken.isIdentifier()) ? assumedMetricNameToken : null;
};
exports.getMetricNameToken = getMetricNameToken;
const getFromKeywordToken = (currentToken) => {
    const selectToken = (0, exports.getSelectToken)(currentToken);
    return selectToken === null || selectToken === void 0 ? void 0 : selectToken.getNextOfType(types_1.TokenType.Keyword, language_1.FROM);
};
exports.getFromKeywordToken = getFromKeywordToken;
const getNamespaceToken = (currentToken) => {
    var _a, _b;
    const fromToken = (0, exports.getFromKeywordToken)(currentToken);
    const nextNonWhiteSpace = fromToken === null || fromToken === void 0 ? void 0 : fromToken.getNextNonWhiteSpaceToken();
    if ((nextNonWhiteSpace === null || nextNonWhiteSpace === void 0 ? void 0 : nextNonWhiteSpace.isDoubleQuotedString()) ||
        ((nextNonWhiteSpace === null || nextNonWhiteSpace === void 0 ? void 0 : nextNonWhiteSpace.isVariable()) && (nextNonWhiteSpace === null || nextNonWhiteSpace === void 0 ? void 0 : nextNonWhiteSpace.value.toUpperCase()) !== language_1.SCHEMA)) {
        // schema is not used
        return nextNonWhiteSpace;
    }
    else if ((nextNonWhiteSpace === null || nextNonWhiteSpace === void 0 ? void 0 : nextNonWhiteSpace.isKeyword()) && ((_a = nextNonWhiteSpace.next) === null || _a === void 0 ? void 0 : _a.is(types_1.TokenType.Parenthesis, '('))) {
        // schema is specified
        const assumedNamespaceToken = (_b = nextNonWhiteSpace.next) === null || _b === void 0 ? void 0 : _b.next;
        if ((assumedNamespaceToken === null || assumedNamespaceToken === void 0 ? void 0 : assumedNamespaceToken.isDoubleQuotedString()) || (assumedNamespaceToken === null || assumedNamespaceToken === void 0 ? void 0 : assumedNamespaceToken.isVariable())) {
            return assumedNamespaceToken;
        }
    }
    return null;
};
exports.getNamespaceToken = getNamespaceToken;
const getTableToken = (currentToken) => {
    var _a;
    const fromToken = (0, exports.getFromKeywordToken)(currentToken);
    const nextNonWhiteSpace = fromToken === null || fromToken === void 0 ? void 0 : fromToken.getNextNonWhiteSpaceToken();
    if (nextNonWhiteSpace === null || nextNonWhiteSpace === void 0 ? void 0 : nextNonWhiteSpace.isVariable()) {
        // TODO: resolve column from variable?
        return null;
    }
    else if ((nextNonWhiteSpace === null || nextNonWhiteSpace === void 0 ? void 0 : nextNonWhiteSpace.isKeyword()) && ((_a = nextNonWhiteSpace.next) === null || _a === void 0 ? void 0 : _a.is(types_1.TokenType.Parenthesis, '('))) {
        return null;
    }
    else {
        return nextNonWhiteSpace;
    }
};
exports.getTableToken = getTableToken;
const defaultTableNameParser = (token) => {
    const parts = token === null || token === void 0 ? void 0 : token.value.split('.');
    if ((parts === null || parts === void 0 ? void 0 : parts.length) === 1) {
        return { table: parts[0] };
    }
    else if ((parts === null || parts === void 0 ? void 0 : parts.length) === 2) {
        return { schema: parts[0], table: parts[1] };
    }
    return null;
};
exports.defaultTableNameParser = defaultTableNameParser;
//# sourceMappingURL=tokenUtils.js.map